import React, { useEffect, useState } from "react";

import actionIcon from "../../assets/img/icon/tnxIcon.png";

import './toDo.css';

const CreatePin = ({ userDetails }) => {
  const [isDone, setIsDone] = useState();
  
  useEffect(() => {
      if (userDetails?.transaction_pin) {
          setIsDone(true);
      }
  }, [userDetails]);

  return (
    <section className="toDoList-card rounded-2">
      <div className="toDo-container">
        <div className="toDo-icon">
          <img src={actionIcon} alt="KYC Verification" className="img-fluid" />
        </div>
        <div className="toDo-text">
          <h4>Create Pin</h4>
          <p>Kindly create a transaction pin for your account</p>
        </div>
        <button 
          className={`toDo-button ${isDone ? "done-button" : ""}`}
          disabled={isDone}
          data-bs-toggle={!isDone ? "modal" : ""}
          data-bs-target={!isDone ? "#transactionPinModal" : ""}
        >
          {isDone ? "Done" : "Set Now"}
        </button>
      </div>
    </section>
  );
};

export default CreatePin;